/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbRemplacementDefinitifDto
 */
export interface FcbRemplacementDefinitifDto {
    /**
     * 
     * @type {number}
     * @memberof FcbRemplacementDefinitifDto
     */
    idremplacement?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbRemplacementDefinitifDto
     */
    idremplacant?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbRemplacementDefinitifDto
     */
    idformateurLocalisationContrat?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbRemplacementDefinitifDto
     */
    idclasseMatiere?: number;
}

/**
 * Check if a given object implements the FcbRemplacementDefinitifDto interface.
 */
export function instanceOfFcbRemplacementDefinitifDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRemplacementDefinitifDtoFromJSON(json: any): FcbRemplacementDefinitifDto {
    return FcbRemplacementDefinitifDtoFromJSONTyped(json, false);
}

export function FcbRemplacementDefinitifDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRemplacementDefinitifDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idremplacement': !exists(json, 'idremplacement') ? undefined : json['idremplacement'],
        'idremplacant': !exists(json, 'idremplacant') ? undefined : json['idremplacant'],
        'idformateurLocalisationContrat': !exists(json, 'idformateurLocalisationContrat') ? undefined : json['idformateurLocalisationContrat'],
        'idclasseMatiere': !exists(json, 'idclasseMatiere') ? undefined : json['idclasseMatiere'],
    };
}

export function FcbRemplacementDefinitifDtoToJSON(value?: FcbRemplacementDefinitifDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idremplacement': value.idremplacement,
        'idremplacant': value.idremplacant,
        'idformateurLocalisationContrat': value.idformateurLocalisationContrat,
        'idclasseMatiere': value.idclasseMatiere,
    };
}

